import { Controller } from "@hotwired/stimulus"

// Expand/collapse the "likelihood to qualify" banner's detail. Toggling the `expanded` class on the
// detail target animates its height via a CSS grid-template-rows transition (0fr <-> 1fr), so the banner
// visibly GROWS to its new size rather than snapping. See _qualification_banner.html.erb and the
// .qualification-detail-wrap rules in application.tailwind.css.
export default class extends Controller {
  static targets = ["detail", "toggle"]

  // Bound to click + Enter/Space on the header row (the whole collapsed bar). preventDefault on keydown so
  // Space doesn't scroll the page when the row is focused.
  toggle(event) {
    if (event && event.type === "keydown") event.preventDefault()
    if (!this.hasDetailTarget) return
    const expanded = this.detailTarget.classList.toggle("expanded")
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", expanded ? "true" : "false")
  }
}
